import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { Badge, Icon, Image, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { CubkCardState } from './lib/cubkProgress.types'
import {
  CUBK_ILLUSTRATIONS,
  CUBK_ILLUSTRATION_ALTS,
  CUBK_TITLES,
  CUBK_SUBTITLES,
} from './cubkCard.constants'
import { useHasEffectiveActionRequired } from './hooks/useHasEffectiveActionRequired'

interface CubkCardCollapsedProps {
  cardState: CubkCardState
  isExpanded: boolean
  onToggle: () => void
}

export const CubkCardCollapsed = ({
  cardState,
  isExpanded,
  onToggle,
}: CubkCardCollapsedProps) => {
  const { hasEffectiveActionRequired: hasActionRequired } =
    useHasEffectiveActionRequired()

  const badge = (
    <Badge color={hasActionRequired ? 'orange' : 'gray'} variant="secondary">
      {hasActionRequired ? 'Action required' : 'No action required'}
    </Badge>
  )

  return (
    <div className="flex flex-col gap-4">
      {/* Mobile: badge above the row */}
      <div className="lg:hidden">{badge}</div>

      {/* Main row */}
      <div className="flex items-center gap-4">
        <Image
          src={CUBK_ILLUSTRATIONS[cardState]}
          alt={CUBK_ILLUSTRATION_ALTS[cardState]}
          width={80}
          height={80}
          objectFit="contain"
          className="hidden lg:block"
        />
        <div className="flex-1 min-w-0">
          <div className="flex flex-col">
            <Text variant={TypographyStyles.H1}>{CUBK_TITLES[cardState]}</Text>
            {CUBK_SUBTITLES[cardState] && (
              <p>
                <span className="label-sm text-neutral-500">Status:</span>{' '}
                <span className="body-sm text-neutral-500">
                  {CUBK_SUBTITLES[cardState]}
                </span>
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-4 shrink-0">
          {/* Desktop: badge inline */}
          <div className="hidden lg:flex">{badge}</div>
          <button
            onClick={onToggle}
            className="flex-shrink-0 p-2"
            aria-label={isExpanded ? 'Collapse card' : 'Expand card'}
            data-testid="cubk-card-toggle"
          >
            <Icon
              icon={isExpanded ? faChevronUp : faChevronDown}
              className="text-neutral-500 shrink-0"
            />
          </button>
        </div>
      </div>
    </div>
  )
}
